export const TRANSLATION_GROUPS_OF_ADMINS_CREATE = Symbol('groups-of-admins-create');
export const GROUPS_OF_ADMINS_CREATE_ROUTE_NAME = Symbol('groups-of-admins.create');

export const GROUPS_OF_ADMINS_CREATE_QUERY_KEY = 'groups-of-admin-create';
export const GROUPS_OF_ADMINS_CREATE_API_URL = 'admin/admin_groups/list_admins_for_create';

export const GROUPS_OF_ADMINS_CREATE_MUTATION_KEY = 'groups-of-admin-create.mutation';
export const GROUPS_OF_ADMINS_CREATE_MUTATION_API_URL = 'admin/admin_groups';
